<template>
  <div class="order-management">
    <div class="header" v-fade-in>
      <h3>充值订单管理</h3>
      <div class="filter">
        <select v-model="statusFilter" @change="loadOrders">
          <option value="">全部</option>
          <option value="pending">待支付</option>
          <option value="paid">已到账</option>
          <option value="expired">已过期</option>
          <option value="cancelled">已取消</option>
        </select>
        <button class="refresh-btn" @click="loadOrders">刷新</button>
      </div>
    </div>

    <div class="order-list" v-if="!isMobile" v-motion="{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay: 0.05 } }">
      <table>
        <thead>
          <tr>
            <th>订单号</th>
            <th>用户</th>
            <th>金额(USDT)</th>
            <th>支付金额</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.orderId">
            <td class="order-id">{{ order.orderId }}</td>
            <td>{{ order.username }}</td>
            <td>{{ order.amount }}</td>
            <td>{{ order.usdtAmount }}</td>
            <td>
              <span :class="'status-' + order.status">{{ statusText(order.status) }}</span>
            </td>
            <td>{{ order.createTime }}</td>
            <td class="actions">
              <button v-if="order.status === 'pending'" class="confirm-btn" @click="confirmOrder(order)">确认到账</button>
              <button v-if="order.status === 'pending'" class="cancel-btn" @click="cancelOrder(order)">取消</button>
              <span v-if="order.status === 'paid'" class="paid-time">{{ order.paidTime }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="empty" v-if="orders.length === 0">暂无订单</div>
    </div>

    <!-- 移动端卡片列表 -->
    <div class="order-cards" v-else v-motion="{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay: 0.05 } }">
      <div class="order-card" v-for="order in orders" :key="order.orderId">
        <div class="card-header">
          <span class="order-no">{{ order.orderId }}</span>
          <span :class="'status-' + order.status">{{ statusText(order.status) }}</span>
        </div>
        <div class="card-body">
          <div class="info-row">
            <span>用户</span>
            <span>{{ order.username }}</span>
          </div>
          <div class="info-row">
            <span>到账金额</span>
            <span class="amount">{{ order.amount }} USDT</span>
          </div>
          <div class="info-row">
            <span>支付金额</span>
            <span>{{ order.usdtAmount }} USDT</span>
          </div>
          <div class="info-row">
            <span>创建时间</span>
            <span>{{ order.createTime }}</span>
          </div>
          <div class="info-row" v-if="order.paidTime">
            <span>到账时间</span>
            <span>{{ order.paidTime }}</span>
          </div>
        </div>
        <div class="card-actions" v-if="order.status === 'pending'">
          <button class="confirm-btn" @click="confirmOrder(order)">确认到账</button>
          <button class="cancel-btn" @click="cancelOrder(order)">取消</button>
        </div>
      </div>
      <div class="empty" v-if="orders.length === 0">暂无订单</div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '@/config/api'

export default {
  name: 'OrderManagement',
  data() {
    return {
      orders: [],
      statusFilter: '',
      isMobile: window.innerWidth <= 768
    }
  },
  mounted() {
    this.loadOrders()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    statusText(status) {
      const map = {
        pending: '待支付',
        paid: '已到账',
        expired: '已过期',
        cancelled: '已取消'
      }
      return map[status] || status
    },
    async loadOrders() {
      try {
        let url = '/api/recharge/admin/list'
        if (this.statusFilter) {
          url += '?status=' + this.statusFilter
        }
        const res = await apiFetch(url)
        if (res.code === 0) {
          this.orders = res.data || []
        }
      } catch (e) {
        console.error(e)
      }
    },
    async confirmOrder(order) {
      if (!confirm(`确认给用户 ${order.username} 到账 ${order.amount} USDT？`)) return
      try {
        const res = await apiFetch(`/api/recharge/admin/confirm/${order.orderId}`, { method: 'POST' })
        if (res.code === 0) {
          alert('已确认到账')
          this.loadOrders()
        } else {
          alert(res.msg || '操作失败')
        }
      } catch (e) {
        alert('操作失败')
      }
    },
    async cancelOrder(order) {
      if (!confirm(`确认取消订单 ${order.orderId}？`)) return
      try {
        const res = await apiFetch(`/api/recharge/admin/cancel/${order.orderId}`, { method: 'POST' })
        if (res.code === 0) {
          alert('已取消')
          this.loadOrders()
        } else {
          alert(res.msg || '操作失败')
        }
      } catch (e) {
        alert('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.order-management { padding: 0; }
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.header h3 { margin: 0; font-size: 15px; font-weight: 600; color: #111; }
.filter { display: flex; gap: 8px; }
.filter select { padding: 6px 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; }
.filter select:focus { outline: none; border-color: #111; }
.refresh-btn { padding: 6px 12px; background: #111; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 13px; }
.refresh-btn:hover { background: #333; }
table { width: 100%; border-collapse: collapse; background: #fff; border: 1px solid #e8e8e8; }
th, td { padding: 10px 12px; text-align: left; border-bottom: 1px solid #f0f0f0; font-size: 13px; }
th { background: #fafafa; font-weight: 600; font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.3px; }
tbody tr:hover { background: #fafafa; }
.order-id { font-family: monospace; font-size: 12px; color: #666; }
.status-pending { color: #666; font-weight: 500; }
.status-paid { color: #111; font-weight: 600; }
.status-expired { color: #bbb; }
.status-cancelled { color: #999; text-decoration: line-through; }
.actions { display: flex; gap: 6px; }
.confirm-btn { padding: 4px 10px; background: #111; color: #fff; border: none; border-radius: 3px; cursor: pointer; font-size: 12px; }
.confirm-btn:hover { background: #333; }
.cancel-btn { padding: 4px 10px; background: #fff; color: #666; border: 1px solid #ddd; border-radius: 3px; cursor: pointer; font-size: 12px; }
.cancel-btn:hover { border-color: #111; color: #111; }
.paid-time { font-size: 12px; color: #999; }
.empty { text-align: center; padding: 40px; color: #999; }
.order-cards { display: flex; flex-direction: column; gap: 12px; }
.order-card { background: #fff; border: 1px solid #e8e8e8; }
.card-header { display: flex; justify-content: space-between; padding: 10px 12px; background: #fafafa; border-bottom: 1px solid #f0f0f0; }
.order-no { font-family: monospace; font-size: 12px; color: #666; }
.card-body { padding: 12px; }
.info-row { display: flex; justify-content: space-between; padding: 5px 0; font-size: 13px; }
.info-row span:first-child { color: #999; }
.amount { color: #111; font-weight: 600; }
.card-actions { display: flex; gap: 8px; padding: 12px; border-top: 1px solid #f0f0f0; }
.card-actions .confirm-btn, .card-actions .cancel-btn { flex: 1; padding: 8px; }
</style>
